import React from 'react';

import { getSelectLabel, lang, remCss } from 'src/helpers';
import constants from 'src/constants';
import { MCButton } from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';

export default class TreatmentItem extends React.PureComponent {
  render() {
    let { item } = this.props;
    let { data } = item;

    return (
      <div className={'mc-flex-col'} style={{ maxWidth: 400 }}>
        <div className={'mc-flex'}>
          {data?.tagRecommendations?.length > 0 && (
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-value-618'}>{lang.t(LANG_CONST.recommendations)}</div>
              <div className={'mc-flex mc-wrap'}>
                {data?.tagRecommendations?.map((item, i) =>
                  item.tags.map((tag) => (
                    <MCButton
                      quaternary
                      small
                      rounded
                      light
                      style={{
                        paddingHorizontal: remCss(12),
                        paddingVertical: remCss(8)
                      }}
                      key={i + tag}
                    >
                      {tag.trim()}
                    </MCButton>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
        <div className={'mc-flex-10-col'}>
          <div className={'mc-value-618'}>{lang.t(LANG_CONST.prescribe_medicine)}</div>
          <div className={'mc-flex mc-flex-start'}>
            <div className={'mc-grow mc-label-516'} style={{ maxWidth: remCss(110) }}>
              {lang.t('Medicine name')}
            </div>
            <div className={'mc-grow mc-label-516 mc-plr10'}>{lang.t('Dosage')}</div>
            <div className={'mc-grow mc-label-516'} style={{ maxWidth: remCss(80) }}>
              {lang.t('Duration')}
            </div>
          </div>
          {data.medicines.map((item, i) => (
            <div className={'mc-flex mc-medicine-row  mc-flex-start'} key={i}>
              <div className={'mc-grow mc-value-418'} style={{ maxWidth: remCss(110) }}>
                {item.name}
              </div>
              <pre className={'mc-grow mc-value-418 mc-plr10'}>
                {item.times
                  .map(
                    (time) =>
                      item.doze + ' ' + getSelectLabel(constants.general.medicine_times, time)
                  )
                  .join(', ') +
                  '\n (' +
                  getSelectLabel(constants.general.medicine_period, item.period) +
                  ')'}
              </pre>
              <div className={'mc-grow mc-value-418'} style={{ maxWidth: remCss(80) }}>
                {item.days + ' Days'}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
